import { useNavigate } from "react-router-dom";

/**
 * <GatedLink to="/hr/dashboard">
 *   {children}
 * </GatedLink>
 *
 * If the user is authenticated, navigates immediately. Otherwise the click
 * is silently ignored — the user is expected to log in via the dedicated
 * LOGIN button on the Hub before any card becomes interactive.
 *
 * Authentication = presence of cpi_session_token in sessionStorage (per-tab,
 * so a new tab/window starts unauthenticated and must log in fresh).
 */
export const isAuthenticated = () => {
  try { return !!sessionStorage.getItem("cpi_session_token"); } catch { return false; }
};

export const GatedLink = ({ to, onRequireLogin, className, children, "data-testid": testId, ...rest }) => {
  const navigate = useNavigate();
  const authed = isAuthenticated();
  const handleClick = (e) => {
    e.preventDefault();
    if (authed) {
      navigate(to);
    }
    // else: do nothing — login is gated to the LOGIN button on the Hub.
    // `onRequireLogin` is intentionally ignored to avoid duplicate auth flows.
  };
  return (
    <a
      href={authed ? to : undefined}
      onClick={handleClick}
      className={className}
      data-testid={testId}
      aria-disabled={!authed}
      {...rest}
    >
      {children}
    </a>
  );
};

export default GatedLink;
